import React from 'react'

export const TestimonialCard = ({ name, statement, author }) => {
  return (
    <div className="testimonial-card">
      <h3 className="testimonial-title">{name}</h3>

      <p className="testimonial-text">
        {statement}
      </p>

      <div className="testimonial-author">
        {author}
      </div>
    </div>
  );
};